/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Broad Institute
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */

const GtexSelection = function (gene, snp) {

    this.geneColors = {};
    this.gene = null;
    this.snp = null;
    this.genesCount = 0;

    if (gene) {
        this.gene = gene.toUpperCase();
        this.geneColors[this.gene] = brewer[this.genesCount++];

    }
    if (snp) {
        this.snp = snp.toUpperCase();
    }

}

GtexSelection.prototype.addGene = function (geneName) {
    if (!this.geneColors[geneName.toUpperCase()]) {
        this.geneColors[geneName.toUpperCase()] = brewer[this.genesCount++];
    }
}

GtexSelection.prototype.colorForGene = function (geneName) {
    return this.geneColors[geneName.toUpperCase()];
}

var brewer = new Array();
// Set +!
brewer.push("rgb(228,26,28)");
brewer.push("rgb(55,126,184)");
brewer.push("rgb(77,175,74)");
brewer.push("rgb(166,86,40)");
brewer.push("rgb(152,78,163)");
brewer.push("rgb(255,127,0)");
brewer.push("rgb(247,129,191)");
brewer.push("rgb(153,153,153)");
brewer.push("rgb(255,255,51)");

// #Set 2
brewer.push("rgb(102, 194, 165");
brewer.push("rgb(252, 141, 98");
brewer.push("rgb(141, 160, 203");
brewer.push("rgb(231, 138, 195");
brewer.push("rgb(166, 216, 84");
brewer.push("rgb(255, 217, 47");
brewer.push("rgb(229, 196, 148");
brewer.push("rgb(179, 179, 179");

//#Set 3
brewer.push("rgb( 141, 211, 199");
brewer.push("rgb(255, 255, 179");
brewer.push("rgb(190, 186, 218");
brewer.push("rgb(251, 128, 114");
brewer.push("rgb(128, 177, 211");
brewer.push("rgb(253, 180, 98");
brewer.push("rgb(179, 222, 105");
brewer.push("rgb(252, 205, 229");
brewer.push("rgb(217, 217, 217");
brewer.push("rgb(188, 128, 189");
brewer.push("rgb(204, 235, 197");
brewer.push("rgb(255, 237, 111");



export default GtexSelection;
